<div class="w-12">
    <div class="w-6 w-7-m w-7-s overlapped-component__large">
        <div class="ratio-overlapped-component">
            @if (!!component.is_larger_video) {
            <local-vimeo-player class="rf"
                                [video-id]="component.larger_video_url"
                                [autoplay-in-viewport]="component.larger_video_autoplay"
                                [controls]="false"
                                [background]="component.larger_video_background_mode" />
            } @else {
            @if (component.larger_image) {
            <href [link]="component.larger_image_link">
                <img [dfImage]="component.larger_image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     [ratio]="0.67"
                     fill>
            </href>
            }
            }
        </div>
        @if (client.sizeId > 1 && component.cta_text) {
        <div class="w-12 m-t-8 p-b-8 center overlapped-component__button">
            <href [link]="component.cta_url">
                <action [ngClass]="component.cta_style || 'button-inline'">
                    <span *iCms="'cta_text' of component"></span>
                </action>
            </href>
        </div>
        }
    </div>

    <div class="w-6 w-5-m w-5-s p-r-8-x p-r-8-l p-l-8-x p-l-8-l overlapped-component__small">
        @if (client.sizeId > 1) {
        <div class="p-t-5">
            <ng-container *ngTemplateOutlet="contentTpl; context: { $implicit: component }" />
        </div>
        } @else {
        <div class="ratio-1-1"></div>
        }
        @if (component.smaller_image || (component.is_smaller_video && component.smaller_video_url)) {
        <div class="m-t-8-x m-t-8-l ratio-overlapped-component">
            @if (!!component.is_smaller_video) {
            <local-vimeo-player class="rf"
                                [video-id]="component.smaller_video_url"
                                [autoplay-in-viewport]="component.smaller_video_autoplay"
                                [controls]="false"
                                [background]="component.smaller_video_background_mode" />
            } @else if (component.larger_image) {
            <href [link]="component.larger_image_link">
                <img [dfImage]="component.larger_image"
                     [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                     [ratio]="0.67"
                     fill>
            </href>
            }
        </div>
        }
    </div>
    @if (client.isS || client.isM) {
    <div class="w-12 p-a-8 center">
        <ng-container *ngTemplateOutlet="contentTpl; context: { $implicit: component }" />
        @if (component.cta_text) {
        <div class="w-12 m-t-5">
            <href [link]="component.cta_url">
                <button [ngClass]="component.cta_style || 'button-inline'">
                    <span *iCms="'cta_text' of component"></span>
                </button>
            </href>
        </div>
        }
    </div>
    }
</div>

<ng-template #contentTpl
             let-component>
    <h2 class="hero"
        *iCms="'title' of component; content: 'html'; skipEmpty: true"></h2>

    <p class="m-t-5 p1"
       *iCms="'paragraph' of component; content: 'html'; skipEmpty: true"></p>
</ng-template>